// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__pv6X7"};